module.exports = __webpack_public_path__ + "static/media/atlas-1.3afecf13.png";